// src/hooks/useLanguagePersistence.ts
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook to ensure language persists across navigation and page reloads
 * Syncs i18n language with localStorage and cookie
 */
export function useLanguagePersistence() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // On mount, check if there's a saved language
    const savedLanguage = localStorage.getItem("thinkeat_language") || localStorage.getItem("i18nextLng");
    
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }

    // Listen for language changes and persist them
    const handleLanguageChange = (lng: string) => {
      localStorage.setItem("thinkeat_language", lng);
      localStorage.setItem("i18nextLng", lng);
      
      // Set cookie
      document.cookie = `thinkeat_language=${lng}; path=/; max-age=${60 * 60 * 24 * 7}`; // 7 days
    };

    i18n.on("languageChanged", handleLanguageChange);

    // Cleanup
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return { language: i18n.language, changeLanguage: i18n.changeLanguage.bind(i18n) };
}

